import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandFleetinfoAddPage } from './cabsand-fleetinfo-add';

@NgModule({
  declarations: [
    CabsandFleetinfoAddPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandFleetinfoAddPage),
  ],
})
export class CabsandFleetinfoAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-fleetinfo-add/cabsand-fleetinfo-add.module.ts